import { PricesAndPointsSummary } from './PricesAndPointsSummary';

export default PricesAndPointsSummary;
